import { Component, OnInit } from "@angular/core";
import { delay } from "rxjs/operators";
import { User } from "src/_models/user";
import { AuthenticationService } from "src/_services/authentication.service";
import { LoadingService } from "src/_services/loading.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  title = "GAPFrontend";
  currentUser: User;
  loading: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private _loading: LoadingService
  ) {
    this.authenticationService.currentUser.subscribe(
      (x) => (this.currentUser = x)
    );
  }

  ngOnInit() {
    this.listenToLoading();
  }

  /**
   * Listen to the loadingSub property in the LoadingService class. This drives the
   * display of the loading spinner.
   */
  listenToLoading(): void {
    this._loading.loadingSub
      .pipe(delay(0)) // This prevents a ExpressionChangedAfterItHasBeenCheckedError for subsequent requests
      .subscribe((loading) => {
        this.loading = loading;
      });
  }
}
